import { useMutation, useQueryClient } from "react-query";

import { Syllabus, Move } from "../../types";
import SyllabusService from "../../services/Syllabus";

import { QUERY_KEY } from "./useListSyllabi";

function useUpdateSyllabus(onSuccess?: (syllabus: Syllabus) => void) {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      id,
      ...updates
    }: { id: Syllabus["id"] } & Partial<Syllabus> & { moves?: Move["id"][] }) =>
      SyllabusService.updateSyllabus(id, updates),
    {
      onSuccess: (syllabus) => {
        queryClient.invalidateQueries(QUERY_KEY);

        onSuccess?.(syllabus);
      },
    }
  );
}

export default useUpdateSyllabus;
